import React from 'react';

const FiltersContext = React.createContext({
  values: {},
  setFieldValue: (_name: string, _value: any) => {},
});

export default FiltersContext;
